import Badge from "@/tpo/Badge";

export default function InvitedBadge() {
  return (
    <Badge bg="haze" color="dark" withBorder size="xs">
      invited
    </Badge>
  );
}
